import { fromJS } from 'immutable';

const initialState = fromJS({});

export default function globalReducer(state = initialState, action) {
  return state;
}
